import { useQuery } from '@tanstack/react-query';
import { type AuditLine, AuditTable } from '@/components/audit-table';
import { QueryState } from '@/components/feedback/query-state';
import { SkeletonTable } from '@/components/feedback/skeletons';
import { adminQuery } from '@/lib/query';

/** What staff did about this customer: every look, reveal and change, logged. */
export function AuditTab({ customerId }: Readonly<{ customerId: string }>) {
  const trail = useQuery({
    ...adminQuery('customers.tab', { customer_id: customerId, tab: 'audit' }),
    select: (data) => data as AuditLine[],
  });
  return (
    <QueryState
      query={trail}
      label="the audit trail"
      skeleton={<SkeletonTable columns={4} rows={5} pager={false} />}
    >
      {(rows) => (
        <AuditTable
          rows={rows}
          empty="Staff have not looked at this customer."
        />
      )}
    </QueryState>
  );
}
